(function() {
  'use strict';

  angular.module('ringbaPortal')
    .directive('trSelectDropdown', trSelectDropdown);

  function trSelectDropdown() {
    function link(scope, elem, attr, controllers) {
      // Our component controller.
      const controller = controllers[0];
      // The ngModel controller exposed on the DOM.
      const ngModelController = controllers[1];
      // Since the available ngModelControllers are a result of the DOM
      // structure, we have to get them from the link function. However,
      // once the DOM has linked, we can pass the available ngModelController
      // into our component directive controller.
      controller.setNgModelController(ngModelController);
    }

    const directive =  {
      restrict: 'E',
      require: ['trSelectDropdown', 'ngModel'],
      scope: {
        selectPlaceholder: '@', // Displays the placeholder in case no value has been selected
        valueProperty: '@', // If options is an array of objects, which property of the object should be used as value
        labelText: '@',
        labelProperty: '@',
        // ngModel: '=', // Replacement of ng-model
        options: '<', // Array of options
        inlineOption: '<', // Inline option when the first option affects form function
        filterOptions: '<',
        filterName: '@',
        filterExpression: '@',
        selectDisabled: '<'
      },
      controller: 'SelectDropdownController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/select-dropdown/select-dropdown.view.html',
      link: link
    };
    return directive;
  }


})();
